import React from 'react';
import { ShowcaseSection, ShowcaseItem } from '../ShowcaseItem';
import { Table, TableHeader, TableBody, TableRow, TableHead, TableCell, TableCaption } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { AvatarWrapper } from '@/components/ui/avatar';
import { FiEdit, FiTrash2 } from 'react-icons/fi';

const STUDENTS = [
  { id: 1, name: 'Ana Silva', course: 'Matematica', score: 9.2, status: 'Aprovado', variant: 'success' },
  { id: 2, name: 'Bruno Santos', course: 'Portugues', score: 7.5, status: 'Aprovado', variant: 'warning' },
  { id: 3, name: 'Carla Oliveira', course: 'Historia', score: 5.4, status: 'Recuperacao', variant: 'danger' },
  { id: 4, name: 'Daniel Costa', course: 'Fisica', score: 8.7, status: 'Aprovado', variant: 'success' },
  { id: 5, name: 'Elisa Almeida', course: 'Quimica', score: 9.8, status: 'Destaque', variant: 'primary-light' }
];

export function TablesSection() {
  return (
    <ShowcaseSection
      id="tables"
      title="Tables"
      description="Tabelas de dados com header, rows, variantes (highlight, danger)"
    >
      <ShowcaseItem
        label="Table — Estrutura basica"
        description="Tabela simples com header e body"
      >
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Aluno</TableHead>
              <TableHead>Materia</TableHead>
              <TableHead>Nota</TableHead>
              <TableHead>Status</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {STUDENTS.map(s => (
              <TableRow key={s.id}>
                <TableCell>
                  <div className="flex items-center gap-2">
                    <AvatarWrapper
                      name={s.name}
                      size="xs"
                    />
                    <span className="font-bold text-primary-dark">{s.name}</span>
                  </div>
                </TableCell>
                <TableCell>{s.course}</TableCell>
                <TableCell>
                  <strong className="text-primary-dark">{s.score.toFixed(1)}</strong>
                </TableCell>
                <TableCell>
                  <Badge
                    variant={s.variant}
                    size="xs"
                  >
                    {s.status}
                  </Badge>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ShowcaseItem>

      <ShowcaseItem
        label="Table — Com acoes e variantes de linha"
        description="Linha highlight (selecao) + linha danger + acoes inline"
      >
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Curso</TableHead>
              <TableHead>Alunos</TableHead>
              <TableHead>Conclusao</TableHead>
              <TableHead className="text-right">Acoes</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            <TableRow highlight>
              <TableCell>
                <strong>Matematica para o ENEM</strong>
              </TableCell>
              <TableCell>240</TableCell>
              <TableCell>87%</TableCell>
              <TableCell className="text-right">
                <div className="flex justify-end gap-1">
                  <Button
                    variant="ghost"
                    size="xs"
                  >
                    <FiEdit size={14} />
                  </Button>
                  <Button
                    variant="ghost"
                    size="xs"
                  >
                    <FiTrash2 size={14} />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <strong>Portugues - Gramatica</strong>
              </TableCell>
              <TableCell>180</TableCell>
              <TableCell>72%</TableCell>
              <TableCell className="text-right">
                <div className="flex justify-end gap-1">
                  <Button
                    variant="ghost"
                    size="xs"
                  >
                    <FiEdit size={14} />
                  </Button>
                  <Button
                    variant="ghost"
                    size="xs"
                  >
                    <FiTrash2 size={14} />
                  </Button>
                </div>
              </TableCell>
            </TableRow>
            <TableRow danger>
              <TableCell>
                <strong>Historia do Brasil</strong>
              </TableCell>
              <TableCell>0</TableCell>
              <TableCell>0%</TableCell>
              <TableCell className="text-right">
                <Badge
                  variant="danger"
                  size="xs"
                >
                  Sem alunos
                </Badge>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </ShowcaseItem>

      <ShowcaseItem
        label="Table — Com caption"
        description="Tabela com legenda (TableCaption)"
      >
        <Table>
          <TableCaption>Lista dos 5 alunos com melhores notas no bimestre.</TableCaption>
          <TableHeader>
            <TableRow>
              <TableHead>Posicao</TableHead>
              <TableHead>Aluno</TableHead>
              <TableHead>Pontos</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {STUDENTS.map((s, idx) => (
              <TableRow key={s.id}>
                <TableCell>
                  <strong>{idx + 1}º</strong>
                </TableCell>
                <TableCell>{s.name}</TableCell>
                <TableCell>{Math.round(s.score * 100)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </ShowcaseItem>
    </ShowcaseSection>
  );
}
